export default __webpack_public_path__ + "static/media/Ethersense.52fbadaf.jpg";